var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffda44",
    d: "M0 160c0 19.57 3.52 38.32 9.95 55.65L160 229.56l150.05-13.91c6.43-17.33 9.95-36.08 9.95-55.65s-3.52-38.32-9.95-55.65L160 90.44 9.95 104.35C3.52 121.68 0 140.43 0 160Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M310.05 104.35C287.44 43.42 228.8 0 160 0S32.56 43.42 9.95 104.35h300.1ZM9.95 215.65C32.56 276.58 91.2 320 160 320s127.44-43.42 150.05-104.35H9.95Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain);
export default __webpack_public_path__ + "static/media/Spain.7ffb75236f689e592e0e02bc9687ff50.svg";
export { ForwardRef as ReactComponent };